// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"59a5e927","239":"7c6c31cb","296":"ba2e7108","453":"ebbdada9","455":"fe9f8443","510":"25ca8348","891":"137df329"}[chunkId] + ".chunk.js";
};